import React from "react";
import styles from "./calculdora.module.css";

const BotonClear = ({ setValor }) => {
  return (
    <div
      className={styles.clear}
      onClick={() => {
        setValor("");
      }}
    >
      Clear
    </div>
  );
};

export default BotonClear;
